import styles from './index.module.scss'
import { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { GenerateContext } from '../../../hooks/GenerateContext';
import ResolutionSelection from './ResolutionSelection/ResolutionSelection';
import { COMMODITY_SCENE_MODE} from '@utils/CONST'
import PSAIModal from "@PSAIComponents/PSAIModal";
import ImageCropper from './ImageCropper'
import Utils from '@utils/utils'

const ResolutionSelectionWrap = () => {
    const {
        // 商品图输出比例
        outputRatio, setOutputRatio,
        // 商品图输出宽度
        outputWidth, setOutputWidth,
        // 商品图输出高度
        outputHeight, setOutputHeight,
        setInputImageTransform,
        // 商品自定义场景配置
        refImgConfig,
        sceneKeyList,
        setSceneKeyList,
    } = useContext(GenerateContext)

    // 分辨率选择
    const resolutionRef = useRef(null)
    // 参考图初始化宽度
    const sceneKeyInitWidthRef = useRef(null)
    // 参考图初始化高度
    const sceneKeyInitHeightRef = useRef(null)

    // 商品图分辨率是否禁用
    const resolutionDisabled = useMemo(() => {
        // if (!refImgConfig) return false
        // const { refImgMode } = refImgConfig
        // if (refImgMode == COMMODITY_SCENE_MODE.SAME_STYLE) {
        //     return true
        // } else {
        //     return false
        // }
        return sceneKeyList?.length === 0
    }, [sceneKeyList])

    useEffect(() => {
        if (!refImgConfig) return
        const { refImgSize, refImgMode } = refImgConfig
        if (refImgMode == COMMODITY_SCENE_MODE.SAME_STYLE) {
            resolutionRef.current?.customSize(refImgSize.width, refImgSize.height)
        }
    }, [refImgConfig])


    // 构图优化弹窗
    const [isComposeOptOpen, setIsComposeOptOpen] = useState(false)
    const [composeOptLoading, setComposeOptLoading] = useState(false)
    const imageCropperRef = useRef(null)
    const getImageCropperParams = async () => {
        setComposeOptLoading(true)
        const cropperParams = await imageCropperRef.current?.handleConfirm()
        if (!cropperParams) {
            setIsComposeOptOpen(false)
            setComposeOptLoading(false)
            return
        }
        console.log('cropperParams', cropperParams)
        const cropUrl = await Utils.uploadBase64Image(cropperParams?.base64) // 主图
        let refCropUrl = null
        if(cropperParams?.refBase64) refCropUrl = await Utils.uploadBase64Image(cropperParams?.refBase64) //预设背景不带人物的图
        console.log('cropUrl, refCropUrl', cropUrl, refCropUrl)
        setSceneKeyList(prev => prev.map((item, index) => {
            if (index === 0) {
                return {
                    ...item,
                    url: cropUrl,
                    attr: {
                        ...item.attr,
                        refCropUrl: refCropUrl || cropUrl,
                    }
                }
            }
            return item
        }))

        setOutputWidth(cropperParams?.width)
        setOutputHeight(cropperParams?.height)
        setInputImageTransform()
        setIsComposeOptOpen(false)
        setComposeOptLoading(false)
    }

    // 将比例字符串（如 "3:4"）转换为小数
    const ratioStringToDecimal = (ratioStr) => {
        if (!ratioStr || ratioStr === 'custom') return 'custom';

        const parts = ratioStr.split(':');
        if (parts.length !== 2) return null;

        const numerator = parseFloat(parts[0]);
        const denominator = parseFloat(parts[1]);

        if (isNaN(numerator) || isNaN(denominator) || denominator === 0) return null;

        return numerator / denominator;
    }

    // 选择比例下拉框时，对比参考图比例是否一致，需要弹窗
    const handleChange = (w, h, ratio) => {
        console.log('w, h, ratio', w, h, ratio)
        setOutputRatio(ratio)
        setOutputWidth(w)
        setOutputHeight(h)
        setInputImageTransform()

        const calculatedRatio = w / h;
        const ratioDecimal = ratioStringToDecimal(ratio);
        if (ratioDecimal == 'custom') { // 重置初始值
            setSceneKeyList(prev => prev.map((item, index) => {
                if (index === 0) {
                    return {
                        ...item,
                        url: item.attr?.originUrl,
                    }
                }
                return item
            }))
            setOutputWidth(sceneKeyList[0]?.attr?.width)
            setOutputHeight(sceneKeyList[0]?.attr?.height)
            setInputImageTransform()
        } else {
            // 判断计算得到的宽高比是否与传入的比例相等（考虑浮点数精度）
            const isEqual = ratioDecimal && Math.abs(calculatedRatio - ratioDecimal) < 0.01;
            if (!isEqual) {
                setIsComposeOptOpen(true)
            }
        }
    }

    return (
        <div className={styles.Container}>
            <div className={styles.Content}>
                <span>生成图比例</span>
                <ResolutionSelection
                    ref={resolutionRef}
                    disabled={resolutionDisabled}
                    initImgRatio={outputRatio}
                    initImgWidth={outputWidth}
                    initImgHeight={outputHeight}
                    onChange={(w, h, ratio) => handleChange(w, h, ratio)}
                />
            </div>
            <PSAIModal
                title="调整参考图"
                maxWidth={768}
                maskClosable={false}
                open={isComposeOptOpen}
                okText="保存更改"
                okButtonProps={{ loading: composeOptLoading}}
                cancelText="取消"
                onCancel={() => {
                    console.log('====oncancel===')
                    setOutputRatio('custom')
                    setOutputWidth(sceneKeyList[0]?.attr?.width)
                    setOutputHeight(sceneKeyList[0]?.attr?.height)
                    setInputImageTransform()
                    setIsComposeOptOpen(false)
                }}
                onOk={getImageCropperParams}
            >
                <div className={styles.CropperContainer}>
                    <ResolutionSelection
                        ref={resolutionRef}
                        disabled={resolutionDisabled}
                        initImgRatio={outputRatio}
                        initImgWidth={outputWidth}
                        initImgHeight={outputHeight}
                        onChange={(w, h, ratio) => handleChange(w, h, ratio)}
                    />
                    <ImageCropper
                        ref={imageCropperRef}
                        url={sceneKeyList[0]?.attr?.originUrl}
                        refImage={sceneKeyList[0]?.attr?.refImage}
                        aspect={outputRatio == 'custom' ? null : ratioStringToDecimal(outputRatio)} />
                </div>

            </PSAIModal>
        </div>
    )
}


export default ResolutionSelectionWrap